import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { BankAccountForm } from './bank-account';

export default function SwiftAccountForm({ mode, bank, rail, requiredFields, canEdit = true, isOnboarding = false }) {
  const { t } = useTranslation(['onboarding', 'common']);

  const wireSchema = z.object({
    rail: z.string().min(1, t('common:required_field')),
    account_holder_name: z.string().min(1, t('common:required_field')),
    account_holder_type: z.string().min(1, t('common:required_field')),
    iban: z.string().optional(),
    swift_code: z.string().min(1, t('common:required_field')),
    account_number: z
      .string()
      .min(1, t('common:required_field'))
      .regex(/^\d+$/, t('common:invalid_characters')),
    bank_name: z.string().min(1, t('common:required_field')),
    bank_country: z.string().min(1, t('common:required_field')),
    bank_address: z.string().min(1, t('common:required_field')),
  });

  return (
    <div className='space-y-4'>
      <BankAccountForm
        mode={mode}
        bank={{
          rail: 'SWIFT',
          account_holder_name: bank?.account_holder_name || '',
          provider: bank?.provider || 'payoneer',
          virtual_account_id: bank?.virtual_account_id || '',
          account_number: bank?.account_number || '',
          bank_name: bank?.bank_name || '',
          bank_country: bank?.bank_country || 'US',
          bank_address: bank?.bank_address || '',
          account_holder_type: bank?.account_holder_type || 'INDIVIDUAL',
          iban: bank?.iban || '',
          swift_code: bank?.swift_code || '',
          id: bank?.id || '',
        }}
        rail={'SWIFT'}
        requiredFields={requiredFields}
        schema={wireSchema}
        canEdit={canEdit}
        isOnboarding={isOnboarding}
      />
    </div>
  );
}